import React, { Component } from 'react';
import {
    Col, Row, Card, CardBody, Button
} from 'reactstrap';
import { connect } from 'react-redux'
import ScorecardSetupForm from '../../../Corporate/Create/ScorecardSetup/scorecardSetupForm'
import '../../../Corporate/Create/ScorecardSetup/style.scss';
import { findEditData, saveEditedData } from './helper'
import Modal from '../../../../components/UI/Modal/Modal'
import { fetchRiskgradeCategory } from '../../../../components/Services/action';
import * as corporateOnboardingAction from '../../Create/action';
import * as defaultProductAction from '../action'
//import withAuth from '../../../../components/Services/WithAuth';
import { Preloading } from '../../../../components/UI/Preloader/action';
import { setPageView, goolgeAnalyticsEvents } from '../../../../components/GoogleAnalytics/index';
import { Link } from "react-router-dom";

class DefaultProductEditScorecard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dropdownOpen: false,
            riskLevels: [],
            selectedProduct: {},
            scoreCardData: {},
            showModal: false,
            infoModal: false,
            body: "",
            initState: null,
        }
    }
    
    componentDidMount() {
        setPageView('/Admin/corporate/defaultProduct/edit/scorecard', document.location.href)
        if (this.props.location.state) {
            this.setState({
                selectedProduct: this.props.location.state.productData,
                scoreCardData: this.props.location.state.scoreCardData,
            })
        };
        this.props.fetchRiskgradeCategory()
        if (this.props.scorecardData && this.props.scorecardData.length !== 0) {
            this.setState({
                scoreCardData: this.props.scorecardData
            })
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.riskLevels && this.props.riskLevels !== prevProps.riskLevels) {
            this.setState({
                riskLevels: this.props.riskLevels
            })
        }

        if (this.props.riskFactors !== prevProps.riskFactors) {
            this.setState({
                riskFactors: this.props.riskFactors,
            })
        }

        if (Object.keys(this.props.productTemplateEditSuccess).length && this.props.productTemplateEditSuccess !== prevProps.productTemplateEditSuccess) {
            this.props.preloading(false)
            this.setState({
                infoModal: true,
                body: <div><h5 className="text-Success"><i className="fa fa-check-circle"></i>Success</h5>
                    <p>Default Product Edit successful</p>
                    <Link className="btn btn-primary mt-3" color="primary" tag="button" to="../../defaultProduct" >Ok</Link>
                </div>
            }, () => this.toggleModal(),
            )
        }
        else if (Object.keys(this.props.productTemplateEditFailure).length && this.props.productTemplateEditFailure !== prevProps.productTemplateEditFailure) {
            this.props.preloading(false)
            this.setState({
                infoModal: true,
                body: <div><h5 className="text-danger"><i className="fa fa-exclamation-triangle"></i>&nbsp;Failure</h5>
                    <p>Failure in Default Product Edit! &nbsp; {(this.props.productTemplateEditFailure.response && this.props.productTemplateEditFailure.response.data) ? this.props.productTemplateEditFailure.response.data.message : "Something went wrong! Please try again."}</p>
                    <Button color="info" className="mt-5" onClick={this.handleWarningClose}>Ok</Button>
                </div>
            }, () => this.toggleModal())
        }

    }

    handleWarningClose = () => {
        this.toggleModal();
        this.setState({
            infoModal: false
        })
    }
    toggleModal = () => {
        this.setState(prevState => ({
            showModal: !prevState.showModal,
        }))
    }

    saveData = (values) => {
        let object = values
        object.productId = this.state.selectedProduct.id
        this.setState({
            scoreCardData: saveEditedData(this.state.scoreCardData, object, this.props.riskFactors, this.state.selectedProduct.sectionList),
            initState: null
        })
    }

    editScoreCard = (data) => {
        this.setState({
            initState: findEditData(this.state.scoreCardData)
        })
        this.props.fetchRiskfactors(data.sectionList)
        this.toggleModal()
    }

    cancel = () => {
        this.setState({
            initState: null
        })
    }

    handleFinish = () => {
      
        let obj = {
            productData: this.state.selectedProduct,
            productGeography:this.state.selectedProduct.productGeography,
            scorecardOrder:this.state.selectedProduct.scorecardOrder,
            scorecardData: this.state.scoreCardData
        }

        this.props.ProductTemplateEdit(obj);
        this.props.preloading(true)

    }

    getModalBody = () => {
        let form = null;
        if (this.state.showModal) {
            if (this.state.infoModal) {
                form = this.state.body;
            } else {
                form = <ScorecardSetupForm
                    toggle={this.toggleModal}
                    riskLevels={this.state.riskLevels}
                    saveData={(values) => this.saveData(values)}
                    editdata={this.state.initState}
                    riskfactors={this.props.riskFactors}
                    cancel={this.cancel}
                />
            }
        }
        return form;
    }

    render() {
        return (
            <Col>
                <div className="d-flex justify-content-between align-items-center mb-3">
                </div>
                <h5>Scorecard Edit</h5>

                <Card className="pb-70">
                    <CardBody>
                        <section>
                            <div className="header-blue p-3 text-primary font-weight-bold mb-3">Default Product </div>
                            <ul>
                                <li className="px-3 mb-3" >
                                    {this.state.selectedProduct.name ?
                                        <Row className="d-flex align-items-center">
                                            <Col sm="4">{this.state.selectedProduct.name}</Col>
                                            <Col sm="4">{this.state.selectedProduct.counterpartyType}</Col>
                                            <Col sm="4">{this.state.selectedProduct.sectionList ? this.state.selectedProduct.sectionList.length : 0} Section(s)</Col>
                                            <Col sm="4">{this.state.selectedProduct.turnAroundTime} days</Col>
                                            <Col sm="4">₹ {this.state.selectedProduct.price}</Col>
                                            <Col>
                                                <Button type="button" size="sm" color="success" className="w-100" onClick={() => this.editScoreCard(this.state.selectedProduct)}>
                                                    Edit Scorecard</Button>
                                            </Col>
                                        </Row>
                                        : null}
                                </li>
                            </ul>
                        </section>
                    </CardBody>
                </Card>
                <Modal show={this.state.showModal} className={this.state.infoModal ? 'Modal' : 'Large-Modal'} >
                    {this.getModalBody()}
                </Modal>
                <footer className="bg-light footer w-100 text-center">
                    <Button color="primary" onClick={this.handleFinish}>Finish</Button>
                </footer>

            </Col>
        );
    }
}
const mapStateToProps = (state, ownProps) => ({
    riskLevels: state.commonReducer.riskLevels,
    riskFactors: state.corporateOnBoardingCreate.riskFactors,
    productTemplateEditSuccess: state.allDefaultProduct.productTemplateEditSuccess,
    productTemplateEditFailure: state.allDefaultProduct.productTemplateEditFailure,
})

const mapDispatchToProps = (dispatch, ownProps) => ({
    fetchRiskgradeCategory: () => { dispatch(fetchRiskgradeCategory()); },
    fetchRiskfactors: (sectionList) => { dispatch(corporateOnboardingAction.fetchRiskfactors(sectionList)) },
    preloading: (isPreloading) => { dispatch(Preloading(isPreloading)); },
    ProductTemplateEdit: (data) => { dispatch(defaultProductAction.ProductTemplateEdit(data)); }

})

export default connect(mapStateToProps, mapDispatchToProps)(DefaultProductEditScorecard)
